export default __webpack_public_path__ + "static/media/Carnegie_Mellon.29427a63.svg";